import type { Label } from '@/scopes/account/group-responsible/domain/types'

interface SortableParticipant {
  assigned: boolean
  name: string
}

export function sortParticipants<T extends SortableParticipant>(a: T, b: T): number {
  if (a.assigned !== b.assigned) {
    return a.assigned ? -1 : 1
  }
  return a.name.localeCompare(b.name)
}

export const PARTICIPANT_STATUSES: Record<string, Label> = {
  NOT_PAID: { text: 'groups_responsible_not_paid', type: 'error' },
  PARTIAL_PAID: { text: 'groups_responsible_partial_paid', type: 'warning' },
  PAID: { text: 'groups_responsible_paid', type: 'success' },
}
